<template>
    <div class="col-12 table-responsive border">
      <div class="table-wrapper">
        <table class="table table-striped comparison-table" style="min-width: 900px">
            <thead>
            <tr>
                <th class="w-25">Гуруҳлар</th>
                <th>Вилоятлар</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td class="w-25" :title="data[0].code">{{data[0].title}}</td>
                <td class="w-75">
                    <div class="form-group">
                        <!--<label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>-->
                        <treeselect class="form-control" v-model="data[0].provinces" :multiple="true" placeholder="Танланг..." :options="provinces" @input="onChangeProvinces"></treeselect>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="w-25" :title="data[1].code">{{data[1].title}}</td>
                <td class="w-75">
                    <div class="form-group">
                        <!--<label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>-->
                        <treeselect class="form-control" v-model="data[1].provinces" :multiple="true" placeholder="Танланг..." :options="provinces" @input="onChangeProvinces"></treeselect>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="w-25" :title="data[2].code">{{data[2].title}}</td>
                <td class="w-75">
                    <div class="form-group">
                        <!--<label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>-->
                        <treeselect class="form-control" v-model="data[2].provinces" :multiple="true" placeholder="Танланг..." :options="provinces" @input="onChangeProvinces"></treeselect>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="w-25" :title="data[3].code">{{data[3].title}}</td>
                <td class="w-75">
                    <div class="form-group">
                        <!--<label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>-->
                        <treeselect class="form-control" v-model="data[3].provinces" :multiple="true" placeholder="Танланг..." :options="provinces" @input="onChangeProvinces"></treeselect>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="w-25" :title="data[4].code">{{data[4].title}}</td>
                <td class="w-75">
                    <div class="form-group">
                        <!--<label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>-->
                        <treeselect class="form-control" v-model="data[4].provinces" :multiple="true" placeholder="Танланг..." :options="provinces" @input="onChangeProvinces"></treeselect>
                    </div>
                </td>
            </tr>
            </tbody>

        </table>
      </div>
    </div>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    // import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    // import {clone} from '@/shared/utils';
    // import { required } from 'vuelidate/lib/validators'
    import Treeselect from '@riophae/vue-treeselect';
    // import {TAX_TYPES} from '@/shared/constants/auto'

    export default {
        name: "GroupProvincesVue",
        components: {
            Treeselect,
        },
        props: {
            key2: String
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                data: [
                    {
                        title: 'М-1 гуруҳи',
                        code: 'M1',
                        provinces: []
                    },
                    {
                        title: 'М-2 гуруҳи',
                        code: 'M2',
                        provinces: []
                    },
                    {
                        title: 'М-3 гуруҳи',
                        code: 'M3',
                        provinces: []
                    },
                    {
                        title: 'М-4 гуруҳи',
                        code: 'M4',
                        provinces: []
                    },
                    {
                        title: 'М-5 гуруҳи',
                        code: 'M5',
                        provinces: []
                    }
                ],
                provinces: [],
            }
        },
        validations: {

        },
        methods: {
            cancel() {
                this.show = false;
            },
            onChangeProvinces(){
                console.log("onChangeProvinces");
                this.$emit('input', this.data);
            }
        },
        created() {
            const vm = this;
            this.$emit('input', vm.data);

            const promises = [
                    this.$http.get('province/init')
                ];
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    console.log(initData);
                    vm.provinces = initData.provinces;
                    vm.provinces = initData.provinces.map((item) => {
                        item.label = item.name;
                        return item;
                    });
                });

            this.$eventBus.$on('groupProvinces'+this.$props.key2, (data) => {
                console.log("groupProvinces = ");
                console.log(data);
                if (data) {
                    vm.data = data;
                }

            });
        }
        // ,
        // watch: {
        //     // Watch for value change
        //     data: {
        //         immediate: true,
        //         // handle the changed value
        //         handler(val) {
        //             if (val) {
        //                 console.log("1111111")
        //                 console.log(val)
        //                 this.data = val;
        //             }
        //         }
        //     }
        // }
    }
</script>

<style scoped>

</style>